module.exports = __webpack_public_path__ + "img/cotnent.8ef1150b.png";